export enum WidgetEnum {
  MULTI_CHART = 'MULTI_CHART',            // MultiChartWidgetComponent
  THREE_DIM_MODEL = 'THREE_DIM_MODEL',    // ThreeDimModelWidgetComponent
  METRIC_CARDS = 'METRIC_CARDS'     //MeasureCardsComponent
}
